(function () {
  if (customElements.get('lala-sortenfarbe')) return;
  customElements.define('lala-sortenfarbe', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.pauseBtn = this.querySelector('[data-pause]');
      this.index = 0;
      this.stopped = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.holds = 0;
      if (this.slides.length < 2) return;
      var self = this, count = this.slides.length, startX = null;
      this.slides.forEach(function (slide, n) {
        var fill = slide.querySelector('.lsf__fill');
        if (fill) fill.addEventListener('animationend', function () { if (n === self.index) self.go((n + 1) % count); });
      });
      if (this.pauseBtn) this.pauseBtn.addEventListener('click', function () { self.setStopped(!self.stopped); });
      if (false && window.matchMedia('(hover: hover)').matches) {
        this.addEventListener('mouseenter', function () { self.hold(true); });
        this.addEventListener('mouseleave', function () { self.hold(false); });
      }
      this.addEventListener('focusin', function () { self.hold(true); });
      this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.hold(false); });
      this.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX; startX = null;
        if (Math.abs(dx) > 40) self.go((self.index + (dx < 0 ? 1 : -1) + count) % count);
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { self.sync(); });
      document.addEventListener('shopify:block:select', function (e) {
        var i = self.slides.findIndex(function (s) { return s.contains(e.target) || s === e.target; });
        if (i > -1) { self.go(i); self.hold(true); }
      });
      document.addEventListener('shopify:block:deselect', function () { self.holds = 0; self.sync(); });
      this.setStopped(this.stopped);
    }
    go(n) {
      this.index = n;
      this.slides.forEach(function (s, i) {
        s.classList.remove('is-active');
        if (i !== n) { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      void this.offsetWidth;
      var cur = this.slides[n];
      cur.classList.add('is-active');
      cur.removeAttribute('aria-hidden');
      cur.removeAttribute('inert');
    }
    hold(on) { this.holds = on ? 1 : 0; this.sync(); }
    setStopped(on) {
      this.stopped = on;
      this.classList.toggle('is-stopped', on);
      if (this.pauseBtn) this.pauseBtn.setAttribute('aria-label', on ? 'Automatischen Wechsel starten' : 'Automatischen Wechsel anhalten');
      this.sync();
    }
    sync() { this.classList.toggle('is-paused', this.stopped || this.holds > 0 || document.hidden); }
  });
})();
